// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ngw7sIkIIKiUxX0QLi2D {
  padding-top: 2.2rem;
  position: relative;
  background-color: var(--background);
  height: 100vh;
  overflow: hidden;
}
.Ngw7sIkIIKiUxX0QLi2D.hasQueues {
  padding-bottom: 2em;
}
.Ngw7sIkIIKiUxX0QLi2D > .queues {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 4em;
  padding: 0.3em 0.6em;
  background-color: var(--bar-background);
  color: var(--bar-color);
  text-overflow: ellipsis;
  display: flex;
  gap: 0.6em;
  align-items: center;
}
.Ngw7sIkIIKiUxX0QLi2D > .queues > div {
  flex: 2em 0 1;
}
.Ngw7sIkIIKiUxX0QLi2D > .queues > div.active {
  flex: 100% 1 1;
}
.Ngw7sIkIIKiUxX0QLi2D > .queues > div:not(.active) {
  cursor: pointer;
}
.I1IbaRHH91BDfsVegY7F {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 2.2rem;
  padding: 0.2em 0.6em;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.I1IbaRHH91BDfsVegY7F > span:first-child {
  display: flex;
  gap: 1em;
  align-items: center;
}
.I1IbaRHH91BDfsVegY7F > span:first-child > a:first-child {
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1.4rem;
  font-weight: 600;
}
.I1IbaRHH91BDfsVegY7F > span:first-child > a:first-child > span {
  width: 2rem;
  background-color: #4e91fd;
  color: #F2EE53;
  border-radius: 4px;
  font-weight: 600;
  font-size: 1.2rem;
  margin-right: 0.6em;
}
.I1IbaRHH91BDfsVegY7F > span:first-child > nav {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
  background-color: var(--bar-background);
  border-radius: 6px;
  padding: 3px 10px;
}
.I1IbaRHH91BDfsVegY7F > span:first-child > nav > svg > path {
  fill: var(--bar-color);
}
.I1IbaRHH91BDfsVegY7F > span:first-child > nav > a {
  display: flex;
  gap: 0.5em;
  align-items: center;
  text-decoration: none;
  background-color: var(--background);
  font-size: 0.8rem;
  border-radius: 6px;
  padding: 3px 6px;
}
.I1IbaRHH91BDfsVegY7F > span:first-child > nav > a > svg > path {
  transition: all 0.6s;
  fill: var(--bar-color);
}
.I1IbaRHH91BDfsVegY7F > span:first-child > nav > a > span {
  transition: all 0.6s;
  color: var(--bar-color);
}
.I1IbaRHH91BDfsVegY7F > span:first-child > nav > a:hover {
  --bar-color: var(--color);
}
.I1IbaRHH91BDfsVegY7F > span:last-child {
  display: flex;
  gap: 1em;
}
.I1IbaRHH91BDfsVegY7F > span:last-child > button:not([type="button"]) {
  font-size: 1.2rem;
  color: var(--bar-color);
  cursor: pointer;
  opacity: 0.6;
  transition: all 0.6s;
}
.I1IbaRHH91BDfsVegY7F > span:last-child > button:not([type="button"]):hover {
  opacity: 1;
}
.Wene3lgkhzJ7k1L4X9_1 {
  height: 100%;
}
.fill-center {
  height: 100%;
}
._uBLdumUYHf9qzxOniD9 {
  border: 1px solid transparent;
  background-clip: padding-box;
  background-color: var(--bar-background);
  padding: 0.5rem 1em;
  border-radius: var(--dry-border-radius);
  box-shadow: var(--dry-shadow);
}
._uBLdumUYHf9qzxOniD9 > p {
  padding: 0.2em 0;
}
._uBLdumUYHf9qzxOniD9 > p em {
  font-weight: 500;
  background-color: var(--background);
  padding: 0.4em 0.5em;
}
._uBLdumUYHf9qzxOniD9 > pre {
  display: block;
  font-family: monospace;
  background-color: var(--background);
  padding: 0.1em;
  margin: 0.2em;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Ngw7sIkIIKiUxX0QLi2D`,
	"hasQueues": `hasQueues`,
	"queues": `queues`,
	"active": `active`,
	"toolbar": `I1IbaRHH91BDfsVegY7F`,
	"workspace": `Wene3lgkhzJ7k1L4X9_1`,
	"fillCenter": `fill-center`,
	"update": `_uBLdumUYHf9qzxOniD9`
};
export default ___CSS_LOADER_EXPORT___;
